import { render } from "./WidgetBtn.vue?vue&type=template&id=5eba1b73"
import script from "./WidgetBtn.vue?vue&type=script&lang=js"
export * from "./WidgetBtn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__